import React from 'react'
import Typography  from '@mui/material/Typography';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import { saasModernTheme } from 'common/theme/saasModern';

const HeadLineComponent = ({ field }) => {
  return <PrismicRichText field={field} 
  components={{
      paragraph: ({ children }) => (
        <Typography
          variant="h1"
          sx={(theme)=>({
            color: '#111927',
            fontSize: `${saasModernTheme.space[13]}px`,
            fontFamily: saasModernTheme.fontFamily,
            margin: '0 auto',
            fontWeight:'bold',
            '.font-semibold': {
              background:
                saasModernTheme.customColor.backgroundTextGradient,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            },
            [theme.breakpoints.down('sm')]:{
              fontSize: `${saasModernTheme.space[8]}px`,
            }
          })}
        >
          {children}
        </Typography>
      ),
    }}
/>
}

export default HeadLineComponent